// extracted by mini-css-extract-plugin
export default {"noFooter":"qZY_8181"};